const LOAD_DATA_MASTER_PROVINCE         = 'LOAD_DATA_MASTER_PROVINCE'
const LOAD_DATA_MASTER_PROVINCE_SUCCESS = 'LOAD_DATA_MASTER_PROVINCE_SUCCESS'
const LOAD_DATA_MASTER_PROVINCE_FAILED  = 'LOAD_DATA_MASTER_PROVINCE_FAILED'
const UNMOUNT_DATA_MASTER_PROVINCE      = 'UNMOUNT_DATA_MASTER_PROVINCE'

const initialState = {
  loading: true,
  data: null,
  message: null,
  meta: null
}

const provinceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_PROVINCE:
      return {
        ...state,
        loading: true,
        data: null,
        meta: null
      }
    case LOAD_DATA_MASTER_PROVINCE_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        meta: action.payload.meta
      }
    case LOAD_DATA_MASTER_PROVINCE_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED',
        meta: null
      }
    case UNMOUNT_DATA_MASTER_PROVINCE:
      return { 
        ...state, 
        loading: true,
        data: null,
        meta: null
      }
    default:
      return state
  }
}
export default provinceReducer